export const successActionType: { [key: string]: string } = {
  UPLOAD_USERS: 'Created new agents',
  UPLOAD_EDIT_USER: 'Edited bulk agents',
  UPLOAD_USER_NUMBER_MAPPING_ADD: 'Adding numbers',
  UPLOAD_USER_NUMBER_MAPPING_DELETE: 'Deleting numbers',
  UPLOAD_NDRA_CERTIFICATE: 'Uploaded NDRA'
};

export const errorActionType: { [key: string]: string } = {
  UPLOAD_USERS: 'Failed to create',
  UPLOAD_EDIT_USER: 'Failed to edit',
  UPLOAD_USER_NUMBER_MAPPING_ADD: 'Failed to add numbers',
  UPLOAD_USER_NUMBER_MAPPING_DELETE: 'Failed to delete numbers',
  UPLOAD_NDRA_CERTIFICATE: 'Failed to upload NDRA'
};

export enum BulkUploadFileType {
  UPLOAD_NDRA_CERTIFICATE = 'UPLOAD_NDRA_CERTIFICATE'
}

export const originalFileStatus: { [key: string]: string } = {
  INITIATED: 'In progress',
  IN_PROGRESS: 'In progress',
  COMPLETED: 'Download',
  FAILED: 'Failed'
};

export const isCSVFileName = (fileName: string): boolean => {
  const fileExtension = fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase();
  return fileExtension === 'csv';
};

export const convertTypeOfAllocation: { [key: string]: string } = {
  Deallocate: 'Deallocation History',
  Allocate: 'Allocation History'
};
export const AllocationType: { [key: string]: string } = {
  Deallocate: 'Deallocate',
  Allocate: 'Allocate'
};
export const AgentAllocationType: { [key: string]: string } = {
  Deallocate: 'TICKET_DE_ALLOCATION_REQUEST',
  Allocate: 'TICKET_ALLOCATION_REQUEST'
};
export const AgencyAllocationType: { [key: string]: string } = {
  Deallocate: 'TICKET_RESOLUTION_REQUEST',
  Allocate: 'TICKET_CREATION_REQUEST'
};
export const CaseType: { [key: string]: string } = {
  Agency: 'Agency',
  Agent: 'Agent'
};
